module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "featured-club-card"
  }, [_c('h5', [_vm._t("club-card-name")], 2), _vm._v(" "), _c('div', {
    staticClass: "featured-club-card--image"
  }), _vm._v(" "), _c('h3', [_vm._t("club-card-titte")], 2), _vm._v(" "), _c('p', {
    staticClass: "featured-club-card--description"
  }, [_vm._t("club-card-description")], 2), _vm._v(" "), (_vm.buttons) ? [_c('sk-button', {
    attrs: {
      "tertiary": ""
    }
  }, [_vm._v("More Info")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    }
  }, [_vm._v("activate")])] : _vm._e()], 2)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46407e7b","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/static-page/featured-club-card/featured-club-card.vue
// module id = 910
// module chunks = 0